/**
 * Accessibility constants and utilities
 */

// ARIA live region politeness levels
export const ARIA_LIVE = {
  OFF: 'off',
  POLITE: 'polite',
  ASSERTIVE: 'assertive',
} as const;

// Common ARIA roles
export const ARIA_ROLES = {
  ALERT: 'alert',
  BUTTON: 'button',
  DIALOG: 'dialog',
  MAIN: 'main',
  NAVIGATION: 'navigation',
  SEARCH: 'search',
  STATUS: 'status',
  TAB: 'tab',
  TABPANEL: 'tabpanel',
} as const;

// Keyboard navigation
export const KEYBOARD = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: ' ',
  TAB: 'Tab',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
} as const;

// Focus management
export const FOCUSABLE_ELEMENTS = [
  'button:not([disabled])',
  'a[href]',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(', ');

/**
 * Creates a skip link target ID
 */
export const SKIP_LINK_TARGET = 'main-content';
